export default __webpack_public_path__ + "static/media/chef.4f4ab850.jpeg";